import {Button, TextInput} from "omoplay";
import {codeAuthorization, idCheck, joinUserInfo} from "../api/auth/auth.api";
import {useEffect, useState} from "react";
import OMOPlayLogo from "../assets/images/logo_omoplay_black.svg";
import IconCheck from "../assets/images/icon.check.green.svg";
import Loading from "../components/Loading";

const JoinPage = () => {
    const [disabled, setDisabled] = useState(true)
    const [isIdValid, setIsIdValid] = useState()
    const [userId, setUserId] = useState("")
    const [password, setPassword] = useState("")
    const [passwordConfirm, setPasswordConfirm] = useState("")
    const [passwordValid, setPasswordValid] = useState(false)
    const [name, setName] = useState("")
    const [phoneNumber, setPhoneNumber] = useState("")
    const [isRequest, setRequest] = useState(false)
    const [timeLeft, setTimeLeft] = useState(180)
    const [code, setCode] = useState("")
    const [requestCode, setRequestCode] = useState("")
    const [codeConfirm, setCodeConfirm] = useState(false)
    const [isRegistration, setRegistration] = useState(true)
    const [isLoading, setLoading] = useState(false)

    useEffect(() => {
        if (name.length > 1 && userId.length > 5 && /^[A-Za-z0-9]+$/.test(userId) && passwordValid && codeConfirm && isIdValid) {
            setDisabled(false)
        } else {
            setDisabled(true)
        }
    }, [name, userId, passwordValid, codeConfirm, isIdValid]);

    useEffect(() => {
        if (isRequest && !codeConfirm) {
            if (timeLeft <= 0) {
                setRequestCode("");
                return;
            }

            const timer = setInterval(() => {
                setTimeLeft((prev) => prev - 1);
            }, 1000);

            return () => clearInterval(timer);
        }
    }, [timeLeft, isRequest])

    const formatTime = () => {
        const minutes = Math.floor(timeLeft / 60);
        const secs = timeLeft % 60;
        return `${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
    };

    function requestCodeFun() {
        setRequest(true)
        codeAuthorization(phoneNumber).then(({data}) => {
            alert("인증 메시지가 전송되었습니다.")
            setTimeLeft(180)
            setRequestCode(data.data)
        })
    }

    return (
        /*
          모바일 키보드 대응 (2026-08-21)

          증상 = 모바일에서 아이디 입력칸을 누르면 키보드가 올라오면서 화면 내용이 함께 밀려
          **입력칸이 보이지 않는다.**

          원인 3가지가 겹쳐 있었다:
          ① 최상단이 `h-screen`(고정 높이) + 내부가 `h-full` 이라 **페이지가 스크롤되지 않는다.**
             회원가입 폼은 입력칸이 6개라 이미 웬만한 휴대폰 화면보다 길다 → 아래쪽은 아예 닿을 수 없었다.
          ② `justify-center` + `items-center` 로 중앙정렬하면, 내용이 화면보다 길 때
             **넘친 위쪽이 잘리고 스크롤로도 복구되지 않는다.** → auto margin(`m-auto`)으로 바꾼다.
             auto margin 은 여유가 있을 때만 중앙정렬하고, 부족하면 위에서부터 흐른다.
          ③ `100vh` 는 키보드가 올라와도 줄지 않는다 → `100dvh`(동적 뷰포트)로 바꾼다.
             이러면 컨테이너가 키보드만큼 줄고, 브라우저가 포커스된 입력칸을 스크롤해서 보여줄 수 있다.

          폼 폭은 `max-w-[420px]` 로 제한한다(종전에는 제한이 없어 내용이 폭을 결정했다).
        */
        <div className="w-full min-h-screen min-h-[100dvh] flex login-background-gradient">
            {
                isLoading && (
                    <div className="left-0 top-0 w-full fixed z-10 h-full flex-center-all" style={{backgroundColor: "black", opacity: "0.8"}}>
                        <Loading className={"w-20 h-20 absolute"} />
                    </div>
                )
            }
            <div className="flex-1 bg-white flex">
                <div className="m-auto w-full max-w-[420px] px-5 py-8 sm:py-10">
                    <div>
                        {
                            isRegistration ? (
                                <>
                                    <div className="flex justify-center text-[24px] font-medium" style={{marginBottom: "20px"}}>
                                        회원가입
                                    </div>
                                    <div className="text-center font-medium" style={{marginBottom: "43px"}}>회원가입을 환영합니다.</div>
                                    <div className="flex-col gap-4 w-full">
                                        <div className="flex-col gap-2">
                                            <label
                                                className="block text-gray-700 text-sm font-bold"
                                            >
                                                아이디
                                            </label>
                                            <TextInput placeholder="계정 아이디를 입력해주세요." onChange={(e) => {
                                                setUserId(e.target.value)
                                            }} onBlur={(e) => {
                                                idCheck(e.target.value).then(({data}) => {
                                                    setIsIdValid(data.data)
                                                })
                                            }} />
                                            {
                                                isIdValid === false && (<div className="text-red-400">이미 존재하는 아이디 입니다.</div>)
                                            }
                                            {
                                                userId.length < 6 ? (<div className="text-red-400">아이디는 6자리 이상이어야 합니다.</div>) : (
                                                    !/^[A-Za-z0-9]+$/.test(userId) && (<div className="text-red-400">아이디 영문자와 숫자로만 이루어져야 합니다.</div>)
                                                )
                                            }
                                        </div>
                                        <div className="flex-col gap-2">
                                            <label
                                                className="block text-gray-700 text-sm font-bold"
                                            >
                                                비밀번호
                                            </label>
                                            <TextInput type="password" placeholder="비밀번호를 입력해주세요." onChange={(e) => setPassword(e.target.value)} />
                                        </div>
                                        <div className="flex-col gap-2">
                                            <label
                                                className="block text-gray-700 text-sm font-bold"
                                            >
                                                비밀번호 재입력
                                            </label>
                                            <TextInput type="password" placeholder="비밀번호를 다시 입력해주세요"
                                                       onChange={(e) => {
                                                           setPasswordValid(e.target.value === password)
                                                           setPasswordConfirm(e.target.value)
                                                       }} />
                                            {
                                                passwordConfirm.length > 0 && !passwordValid && <div className="text-red-400">비밀번호가 맞지 않습니다.</div>
                                            }

                                        </div>
                                        <div className="flex-col gap-2">
                                            <label
                                                className="block text-gray-700 text-sm font-bold"
                                            >
                                                이름
                                            </label>
                                            <TextInput placeholder="이름을 입력해주세요." onChange={(e) => setName(e.target.value)} />
                                        </div>
                                        <div className="flex-col gap-2">
                                            <label
                                                className="block text-gray-700 text-sm font-bold"
                                            >
                                                휴대폰번호
                                            </label>
                                            <div className="flex gap-2">
                                                <div className="flex-1">
                                                    <TextInput disabled={codeConfirm} placeholder="01012345678" onChange={(e) => setPhoneNumber(e.target.value)} />
                                                </div>
                                                <Button variants="primary" disabled={isRequest || phoneNumber.length < 10}
                                                        value="인증 요청" onClick={requestCodeFun} />
                                            </div>
                                        </div>
                                        <div className="flex-col gap-2">
                                            {/* 입력칸·남은시간·버튼 3개가 한 줄에 들어가면 좁은 화면에서 입력칸이 눌린다 → 모바일은 2줄 */}
                                            <div className="flex flex-col sm:flex-row sm:items-center gap-2">
                                                <div className="flex-1">
                                                    <TextInput disabled={codeConfirm} placeholder="6자리 인증번호를 입력해주세요." onChange={(e) => {
                                                        setCode(e.target.value)
                                                    }} />
                                                </div>
                                                <div className="flex items-center justify-end gap-2">
                                                    {(isRequest && !codeConfirm) && <div>{formatTime()}</div>}
                                                    <Button variants="primary" disabled={!isRequest || codeConfirm} value="인증 확인" onClick={(e) => {
                                                        if (code === requestCode.toString()) {
                                                            alert("인증 되었습니다.")
                                                            setCodeConfirm(true)
                                                        } else {
                                                            alert("인증번호가 맞지 않습니다.")
                                                        }
                                                    }} />
                                                </div>
                                            </div>
                                            <div className="flex gap-1">
                                                <div className="text-red-400">* 오모플레이 채널을 차단한 경우 수신이 불가합니다.</div>
                                            </div>
                                            <div className="flex gap-1">
                                                <div>알림톡을 받지 못하셨나요?</div>
                                                <div className="underline pointer" onClick={requestCodeFun}>알림톡 다시 받기</div>
                                            </div>
                                        </div>
                                        <Button variants="primary" size="large" disabled={disabled} onClick={() => {
                                            setDisabled(true)
                                            setLoading(true)
                                            joinUserInfo(name, userId, passwordConfirm, phoneNumber).then(() => {
                                                setLoading(false)
                                                setRegistration(false)
                                            })
                                        }} value="회원 가입" style={{marginTop: "16px"}} />
                                    </div>
                                    <div className="flex gap-1 mt-[47px]">
                                        <div>이미 회원이신가요?</div>
                                        <div className="underline pointer" onClick={() => window.location.href = "/login"}>로그인 페이지로 이동</div>
                                    </div>
                                </>
                                )
                                : (
                                    <div className="flex-col items-center text-center">
                                        <div className="flex justify-center" style={{marginBottom: "20px"}}>
                                            <img alt="" src={OMOPlayLogo} className="w-full max-w-[272px] h-auto" />
                                        </div>
                                        <div style={{marginBottom: "43px"}}>NO.1 온오프라인 브랜드사 고객 마케팅 서비스</div>
                                        <div className="text-[24px] font-medium">회원가입 완료</div>
                                        <div><img src={IconCheck} alt="Check" width={100} height={100} /></div>
                                        <div className="font-medium">가입한 계정으로 로그인 하세요.</div>
                                        <div className="font-medium">서비스 신청에 필요한 과정을 안내해 드리겠습니다.</div>
                                        {/* 320px 고정폭은 좁은 화면(320~360px)에서 여백을 넘겼다 */}
                                        <Button variants="primary" size="large" onClick={() => window.location.href = "/login"}
                                                value="로그인 페이지로 돌아가기" style={{marginTop: "16px", width: "100%", maxWidth: "320px"}} />
                                    </div>
                                )
                        }
                        </div>
                </div>
            </div>
            {/*
              오른쪽 그라디언트 여백 — 좁은 화면에서는 숨긴다.
              종전에는 `window.innerWidth <= 720` 을 렌더 시점에 한 번 계산해서 판단했는데,
              그 값은 회전·창 크기 변경에 반응하지 않는다. CSS 브레이크포인트가 항상 정확하다.
            */}
            <div className="hidden sm:flex flex-1 flex-center-all"></div>
        </div>
    );
};
export default JoinPage;
